const ID_FORM = '#form';
const SELECTOR_RADIOBUTTONS = '.form__element--radio input';
const CLASS_FORMFIELD = '.formfield';
const CLASS_HASINPUT = 'has-input';

// Constanten für den Kündigungstyp
const ID_OK = '#ok';            // Ordentlich
const ID_AK = '#ak';            // Außerordentlich
const ID_AKF = '#akt_field';    // Freitextfeld für AK

export default class Form{

    constructor(){
        this.init();
    }

    init() {
        let formfields = Array.from(document.querySelectorAll('input[type="text"], input[type="email"], input[type="date"], textarea, select'));
        formfields.forEach(element => {
            element.addEventListener('change', this.hasInput);
        });

        let ok = document?.querySelector(ID_OK);
        let ak = document?.querySelector(ID_AK);

        ok?.addEventListener('change', this.showButton);
        ak?.addEventListener('change', this.showButton);
    }

    hasInput() {
        if(this.value !=''){
            this.classList.add(CLASS_HASINPUT );
        }else{
            this.classList.remove(CLASS_HASINPUT );
        }
        
    }

    showButton() {
        let button = document.querySelector(ID_AKF);
        if(this.getAttribute('id') == 'ok'){
            button.removeAttribute('required');
            button.setAttribute('disabled', 'disabled');
            button.style.display = 'none';
        }else if(this.getAttribute('id') == 'ak') {
            button.removeAttribute('disabled');
            button.setAttribute('required', 'required');
            button.style.display = 'block';
        }
    }
}